var React = require('react');

function IconGraph1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("path",{"fill":"#9e9e9e","d":"M23.6 9.99V13H26V6h-7.2v2.333h3.1l-5.352 5.2a1.219 1.219 0 0 1-1.692 0l-1.4-1.365a3.673 3.673 0 0 0-5.088 0L2 18.355 3.692 20l6.348-6.172a1.219 1.219 0 0 1 1.692 0l1.4 1.365a3.673 3.673 0 0 0 5.088 0z","transform":"translate(-2 -1)","key":1})]);
}

IconGraph1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconGraph1;

IconGraph1.default = IconGraph1;
